import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import ScrollToTop from "./components/scrollToTop";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import coverTable from "./components/coverTable";
import loadGame from "./components/loadGame";
import Faq from "./components/faq";
import toc from "./components/toc";

document.addEventListener('DOMContentLoaded', function () {

    lazyLoad();

    let myLazyLoad = new LazyLoad();

    ScrollToTop();

    MobileBurgerMenu();

    // adaptive table class
    coverTable();

    // iframe on click
    loadGame();

    Faq();

    toc();
});

//header menu
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.main-nav a,span').forEach(link => {
        const wordCount = link.textContent.trim().split(/\s+/).length;
        if (wordCount >= 3) {
            link.style.whiteSpace = 'normal';
        }
    });
});

//header mobile menu
document.addEventListener("DOMContentLoaded", function () {
    const mobileBreakpoint = 1023;

    if (window.innerWidth <= mobileBreakpoint) {
        document.querySelectorAll('.menu-item-has-children > a').forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                const subMenu = this.parentElement.querySelector('.sub-menu');
                if (!subMenu) return;

                const isOpened = this.classList.contains('opened');

                this.classList.toggle('opened', !isOpened);
                subMenu.style.display = isOpened ? 'none' : 'block';
            });
        });
    } else {

        document.querySelectorAll('.menu-item-has-children').forEach(item => {
            let timeout;

            item.addEventListener('mouseenter', () => {
                clearTimeout(timeout);
                const submenu = item.querySelector('.sub-menu');
                if (submenu) submenu.style.display = 'block';
            });

            item.addEventListener('mouseleave', () => {
                const submenu = item.querySelector('.sub-menu');
                timeout = setTimeout(() => {
                    if (submenu) submenu.style.display = 'none';
                }, 200);
            });
        });
        document.querySelectorAll('a').forEach(a => {
            const afterContent = window.getComputedStyle(a, '::after').content;
            if (afterContent === '""') {
                a.classList.add('has-after');
            }
        });
    }
});






